import * as events from "../events/library/libraryEvents";

import {
  createDraftSuccess,
  publishSuccess,
  revertSuccess,
  successAction,
  updateSuccess,
} from "features/Library/SCORM/state/slices/EntityStateSlice";
import { type Dispatcher, type MidnightActionPayload } from "../../../../../interfaces";
import * as backgroundTasksActions from "../../../../BackgroundTasks/state/backgroundTasksActions";
import {
  updateFailedTaskDistributedOperation,
  updateSucceededTaskDistributedOperation,
} from "../../../../BackgroundTasks/state/backgroundTasksActions";
import { createDispatcher } from "../dispatcher";
import { type IMapping } from "./types";

import {
  updateProcessingAction,
  updateProcessingFailureAction,
} from "../../../../Library/SCORM/state/thunks/DetailsThunk";
import { saveThumbnail } from "../../../../Library/SCORM/state/slices/DetailsSlice";
import { notificationReceived } from "../../../../Notifications/state/notificationsActions";

export const scormsMapping = (mapping: IMapping, dispatcher: Dispatcher) => {
  const {
    dispatch,
    dispatchPublishSuccess,
    dispatchBatchOperationSuccess,
    dispatchBatchOperationFailure,
    dispatchMap,
  } = createDispatcher(dispatcher);

  mapping[events.ScormPublishSuccess] = dispatchPublishSuccess<{ id: number; message: string }>(
    publishSuccess,
    (data) => data.message,
  );

  mapping[events.ScormDiscardSuccess] = dispatch(revertSuccess);
  mapping[events.LockScormSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(
    createDraftSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.ScormEditSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(updateSuccess, (message) => ({
    entityId: message.id,
  }));
  mapping[events.ScormUpdateCommandCompleted] = dispatch(successAction);

  mapping[events.ScormTagsAddSuccess] = dispatchBatchOperationSuccess;
  mapping[events.ScormTagsAddFailure] = dispatchBatchOperationFailure;
  mapping[events.ScormTagsEditSuccess] = dispatch(successAction);

  mapping[events.ScormDeletionSuccess] = (payload) =>
    dispatcher(backgroundTasksActions.updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));
  mapping[events.ScormDeletionFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.DeleteAllScormSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.DeleteAllScormFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.ScormVisibilityEditSuccess] = (payload) =>
    dispatcher(backgroundTasksActions.updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));
  mapping[events.ScormVisibilityEditFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.EditScormVisibilitySuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.EditScormVisibilityFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.ScormEditSuccess] = dispatchMap<{ id: number; title: string }, MidnightActionPayload>(
    updateSuccess,
    (message) => ({ entityId: message.id }),
  );

  mapping[events.ScormProcessManifestSuccess] = (payload) => dispatcher(updateProcessingAction(payload));
  mapping[events.ScormProcessingFailure] = (payload) => {
    dispatcher(updateProcessingFailureAction(payload));
    dispatcher(notificationReceived);
  };

  mapping[events.ScormEditThumbnailSuccess] = dispatchMap<{ thumbnailUri: string }, string>(
    saveThumbnail,
    (message) => message.thumbnailUri,
  );
};
